import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import './App.css';
import './mobile.css';

import Header from './Header';
import FooterWrapper from './Footer';
import Layout from './Layout';
import TextZoomSlider from './TextZoomSlider';
import PadaPaatham from './PadaPaatham';
import SandhiPage from './SandhiPage';
import VikrutiPaatham from './VikrutiPaatham';
import Varnakrama from './Varnakrama';
import Vibhakti from './Vibhakti';
import Pratyahara from './Pratyahara';
import Varnamalika from './Varnamalika';
import PuzzleLayout from './PuzzleLayout';
import Shabdaadhikaaraha from './Shabdaadhikaaraha';
import Subantarupaani from './Subantarupaani';
import DemoLayout from './DemoLayout';
import SpardhaLayout from './SpardhaLayout';
import Krudantha from './Krudantha';
import GhiRupa from './GhiRupa';
import VarnasaaraPrototypes from './prototype/VarnasaaraPrototypes';
import TestDashboard from './TestDashboard';
import SandhiVikrutiTest from './SandhiVikrutiTest';
import PadamProcessTest from './PadamProcessTest';
import VedaIndex from './VedaIndex';
import VedaIndexBrowser from './VedaIndexBrowser';
import { warmUpBackend } from './Services/HttpClient';

const App = () => {
  // Warm up Cloud Run backend on app load to avoid cold start delays
  useEffect(() => {
    warmUpBackend();
  }, []);
  return (
    <div id="App">
      <TextZoomSlider />
      <Header />
      <div className="main-container vedicaccents">
          <Routes>
            <Route path="/" element={<VedaIndex />} />
            <Route path="/vikruti" element={<VikrutiPaatham />} />
            <Route path="/krama" element={<VikrutiPaatham paathamType="krama" />} />
            <Route path="/jata" element={<VikrutiPaatham paathamType="jataa" />} />
            <Route path="/ghana" element={<VikrutiPaatham paathamType="ghana" />} />
            <Route path="/sandhi" element={<SandhiPage />} />
            <Route path="/padapaatham" element={<PadaPaatham />} />
            <Route path="/varnakrama" element={<Varnakrama type="shuddha" />} />
            <Route path="/vibhakti" element={<Vibhakti />} />
            <Route path="/spardha" element={<SpardhaLayout />} />
            <Route path="/PuzzleLayout" element={<PuzzleLayout />} />
            <Route path="/pratyahara" element={<Pratyahara />} />
            <Route path="/Varnamalika" element={<Varnamalika />} />
            <Route path="/DemoLayout" element={<DemoLayout />} />
            <Route path="/Shabdaadhikaaraha" element={<Shabdaadhikaaraha />} />
            <Route path="/Subantarupaani" element={<Subantarupaani />} />
            <Route path="/Krudantha" element={<Krudantha />} />
            <Route path="/GhiRupa" element={<GhiRupa />} />
            <Route path="/varnasaara-prototypes" element={<VarnasaaraPrototypes />} />
            <Route path="/test-dashboard" element={<TestDashboard />} />
            <Route path="/sandhi-vikruti-test" element={<SandhiVikrutiTest />} />
            <Route path="/padam-process-test" element={<PadamProcessTest />} />
            <Route path="/veda-index" element={<VedaIndexBrowser />} />
          </Routes>
      </div>
      {/* <Keyboard /> */}
      <FooterWrapper />
    </div>
  );
};

export default App;
